// src/pages/AchievementsPage.js – Cinematic enhanced
import React from 'react';
import Achievements from '../components/Achievements';
import Chat from '../components/Chat';

export default function AchievementsPage() {
  return (
    <div className="page-shell" style={{ paddingBottom:'60px' }}>
      <div className="section-title animate-fade-in">ACHIEVEMENTS</div>
      <div className="animate-fade-in">
        <Achievements />
      </div>
      <Chat />
    </div>
  );
}
